module.exports = __webpack_public_path__ + "img/eicon2.aa3eb92e.png";